import React, { ComponentPropsWithRef } from 'react'
import styles from './styles/btn-primary.module.scss'
import classNames from 'classnames'

export interface Props {
  onClick?: () => any
  size?: 'small' | 'medium' | 'large'
  border?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  isDisabled?: boolean
  fullWidthAtMobile?: boolean
  controlSubscribeModal?: boolean
  href?: string
  linkStyle?: boolean
  buttonProps?: ComponentPropsWithRef<'button'>
}

/**
 * WTN primary button
 */

const BtnPrimary: React.FC<Props> = ({
  onClick,
  children,
  size,
  buttonProps,
  href,
  controlSubscribeModal,
  className = '',
  type = 'button',
  isDisabled = false,
  border = true,
  linkStyle = false,
  fullWidthAtMobile = false,
}) => {
  const subscribeModalProps = controlSubscribeModal ? { 'data-subscribe-modal-open': '' } : {}

  if (href)
    return (
      <a
        className={classNames(styles.primaryBtn, styles[size || ''], className, {
          [styles.disabled]: isDisabled,
          [styles.noBorder]: !border || linkStyle,
          [styles.fullWidthAtMobile]: fullWidthAtMobile,
          [styles.linkStyle]: linkStyle,
        })}
        href={href}
      >
        {children}
      </a>
    )
  return (
    <button
      disabled={isDisabled}
      type={type}
      className={classNames(styles.primaryBtn, styles[size || ''], className, {
        [styles.disabled]: isDisabled,
        [styles.noBorder]: !border || linkStyle,
        [styles.fullWidthAtMobile]: fullWidthAtMobile,
        [styles.linkStyle]: linkStyle,
      })}
      onClick={onClick}
      {...subscribeModalProps}
      {...(buttonProps || {})}
    >
      {children}
    </button>
  )
}

export default BtnPrimary
